import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { Dialog, DialogTitle, DialogContent, Button, DialogContentText, Divider, Grid, Typography, IconButton, Tooltip, CircularProgress, ListItemText } from '@mui/material'
import CloseIcon from '@material-ui/icons/Close';
import AttachFile from '@material-ui/icons/AttachFile';
import { makeStyles } from "@mui/styles";
import { TicketCommentsList } from './TicketCommentsList'
import { TicketNewComment } from './TicketNewComment'
import { getAttachments, getSupplierTickets, getCustomFields, getCategory } from '../../../Store/Ducks/duckTickets'
import { useState } from 'react';
import { handleDownloadAttachment } from '../../../Utils/downloadFiles'

const useStyles = makeStyles((theme) => ({
  grid: {
    alignItems: "center",
    backgroundColor: "#f5f5f5",
  },
  gridTitle: {
    alignItems: "center",
    backgroundColor: "#002B5C",
    color: 'whitesmoke'
  },
  gridButton: {
    backgroundColor: "#f5f5f5"
  },
  content: {
    padding: '10px 10px',
    fontFamily: 'roboto',
    fontSize: '16px',
  },
  closeIcon: {
    color: "white",
  },
  title1: {
    fontSize: '18px', 
    fontFamily: 'Lato, Arial, sans-serif'
  },
  text13: {
    color: '#888', 
    fontSize: '14px', 
    fontFamily: 'Lato, Arial, sans-serif'
  },
  text14: {
    color: '#666', 
    fontSize: '15px',
    fontFamily: 'Lato, Arial, sans-serif'
  }
}));

export const TicketComments = ({ openComments,
  openNewComment,
  handleClose,
  ticketNumber,
  ticketTitle,
  ticketCategory,
  ticketCategoryId,
  ticketCreated,
  ticketDescription,
  customFieldsValues,
  attachedFilesHeader,
  setOpenNewComment,
  setUpdateComment,
  email,
  tickets }) => {

  const dispatch = useDispatch()
  const classes = useStyles();
  const [loadingAttHeader, setLoadingAttHeader] = useState(false);
  const [attHeader, setAttHeader] = useState([])
  const [showAttachments, setShowAttachments] = useState(false);
  const supplierTickets = useSelector(store => store.tickets?.data?.supplierTickets) || []
  const customFields = useSelector(store => store.tickets?.data?.customFields) || [];
  const categories = useSelector(store => store.tickets?.data?.categories) || [];

  useEffect(() => {
    tickets.length > 0 && dispatch(getSupplierTickets(email))
    dispatch(getCategory(email))
  }, [dispatch, email, ticketCategoryId])

  useEffect(() => {
    const selectedCategory = categories.find(category =>
      category.category === categories.find(cat => cat.id === ticketCategoryId)?.category &&
      category.id === ticketCategoryId
    );
    if (selectedCategory) {
      dispatch(getCustomFields(selectedCategory.invgateID));
    }
  }, [dispatch, categories, ticketCategoryId]);

  const handleOpenNewComment = () => {
    setOpenNewComment(true);
  }

  const handleToggleAttachments = () => {
    if (showAttachments) {
      setShowAttachments(false);
    } else {
      const promises = attachedFilesHeader.map(idAttachment => dispatch(getAttachments(idAttachment)));
      setLoadingAttHeader(true);
      Promise.all(promises)
        .then((attachments) => {
          setAttHeader(attachments);
          setLoadingAttHeader(false);
          setShowAttachments(true);
        })
        .catch((error) => {
          console.log(error);
          setLoadingAttHeader(false);
        });
    }
  };

  const findLabelByUid = (uid) => {
    const field = customFields.find(field => field.uid === uid);
    return field ? field.label : '';
  }

  return (
    <>
      <Dialog open={openComments} onClose={handleClose} fullWidth maxWidth='md' sx={{ p: 1 }} className={classes.content}>
        <Grid container xs={12} className={classes.gridTitle} >
          <Grid id={1} item xs={9.5} >
            <DialogTitle className={classes.content}>
              <div onClose={handleClose} className={classes.title1}>{ticketTitle}</div >
            </DialogTitle>
          </Grid>
          <Grid id={2} item xs={1.5} >
            <DialogTitle className={classes.content}>
              <Typography onClose={handleClose} className={classes.title1}>#{ticketNumber}</Typography >
            </DialogTitle>
          </Grid>
          <Grid id={3} item xs={1} justifyContent="flex-end" >
            <DialogTitle className={classes.content}>
              <IconButton onClick={handleClose}>
                <CloseIcon className={classes.closeIcon} />
              </IconButton>
            </DialogTitle>
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={0} xs={12} className={classes.grid} >
          <DialogContent className={classes.content} style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
            {
              customFieldsValues && Object.entries(customFieldsValues).map(([key, value]) => {
                const label = findLabelByUid(key);
                const formatedValue = value.split("->")[1] || value

                return (
                  <div key={key} className={classes.text13}>
                    {label && `${label}: `}
                    <span style={{color: '#666', fontSize: '14px', fontFamily: 'Lato, Arial, sans-serif'}}>{formatedValue}</span>
                  </div>
                );
              })
            }
          </DialogContent>
        </Grid>
        <Divider />
        <Grid container spacing={0} xs={12} className={classes.grid}>
          <Grid item xs={10} >
            <DialogContent className={classes.content}>
              <div className={classes.text13}>
                Categoría: <span className={classes.text14}>{ticketCategory}</span>
              </div >
            </DialogContent>
          </Grid>
          <Grid item xs={2} justifyContent="flex-end">
            <DialogContent className={classes.content}>
              <div className={classes.text14}>{moment(ticketCreated).utcOffset(0, true).format("YYYY-MM-DD HH:mm")}</div >
            </DialogContent>
          </Grid>
        </Grid>
        <Divider />
        <Grid item xs={12} className={classes.grid}>
          <DialogContent className={classes.content}>
            <div className={classes.text13}>
              Descripción: <span className={classes.text14} /* style={{lineHeight: '23.8px'}} */>{ticketDescription}</span>
            </div>
          </DialogContent>
        </Grid>
        <Divider />
        <Grid container item xs={12} direction="row" justifyContent="center" alignItems="center" className={classes.gridButton} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <DialogContent className={classes.content}>
              <Button
                onClick={handleOpenNewComment}
                variant="contained"
                size="small"
                style={{ margin: '10px 0', fontFamily: 'Lato, Arial, sans-serif' }}
              > Añadir comentario </Button>
            </DialogContent>
          </Grid>
          {attachedFilesHeader?.length > 0 && <Grid item xs={1}>
            <Tooltip title="Ver Adjuntos">
              <IconButton onClick={handleToggleAttachments}>
                <AttachFile />
              </IconButton>
            </Tooltip>
          </Grid>}
          {loadingAttHeader ? (
            <Grid item xs={12} align="left">
              <CircularProgress />
            </Grid>
          ) : showAttachments && attHeader && attHeader.length > 0 && attHeader.map(
            attachment => (<Grid item xs={12} style={{ textAlign: "left" }}>
              <ListItemText
                key={attachment.payload.data.id}>
                <Typography
                  className={classes.text13}
                  component="span"
                  //variant="body2"
                  color="text.primary"
                >
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a style={{ paddingLeft: "16px" }} href="#" onClick={() => handleDownloadAttachment(attachment.payload.data.url, attachment.payload.data.name)}>
                    {attachment.payload.data.name}
                  </a></Typography>
              </ListItemText>
            </Grid>)
          )}
        </Grid>
        <Divider />
        <DialogContent style={{ padding: 0 }}>
          <TicketCommentsList
            ticketNumber={ticketNumber}
            handleClose={handleClose}
            supplierTickets={supplierTickets}
            isEdit
          />
        </DialogContent>
      </Dialog >

      <Dialog open={openNewComment} onClose={handleClose} fullWidth maxWidth='sm' >
        <DialogTitle textAlign="center" onClose={handleClose} >Añadir Comentarios</DialogTitle>
        <DialogContent>
          <TicketNewComment
            ticketNumber={ticketNumber}
            handleClose={handleClose}
            supplierTickets={supplierTickets}
            setOpenNewComment={setOpenNewComment}
            setUpdateComment={setUpdateComment}
            isEdit
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
